import React, { useMemo } from 'react';
import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';

interface IProps {
  operations: Operation[],
  operationsSelected: string[]
}

const ScriptCreatorPlugin: React.FC<IProps> = React.lazy(() => importFromS3('script-creator-plugin'));

export const ScriptCreatorPluginContainer: React.FC<IProps> = ({ operations, operationsSelected }: IProps) => {
  const { isLoading, operation: impersonatedOperation } = useImpersonatedOperation();
  const selectedOperations = useMemo(() => impersonatedOperation 
    ? [impersonatedOperation.operationId] 
    : operationsSelected, 
  [impersonatedOperation, operationsSelected]);

  if (isLoading || !selectedOperations.length) return null;  
  return (
    <ScriptCreatorPlugin
      operations={operations}
      operationsSelected={selectedOperations}
    />
  );
};
